import { createJSONRequest } from '@/api/create-request'

export interface DownloadableRequestResponse {
  message: string
}

export interface ResolveTokenResponse {
  download_url: string
  file_name: string
}

export function requestDownloadable (email: string, itemType: string, recaptchaToken?: string): Promise<DownloadableRequestResponse> {
  return createJSONRequest({
    url: '/api/downloadables/request',
    method: 'POST',
    data: { email, item_type: itemType, recaptcha_token: recaptchaToken },
  })
}

export function resolveDownloadToken (token: string): Promise<ResolveTokenResponse> {
  return createJSONRequest({
    url: `/api/downloadables/${token}`,
    method: 'GET',
  })
}
